import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCity,faRoute,faQuoteRight, faMoon, faCrown, faCalendarDay, faCalendarDays, faHeadset, faLock, faTableColumns, faPaperPlane, faHome, faKey, faMessage, faSpinner, faUserSlash, faIdCard, faCalculator, faClipboardCheck, faCakeCandles,faPhoneSlash,faRotate, faGauge,faBuilding, faCalendarTimes, faBed, faWallet, faCoins, faEdit,faFileInvoice,faCashRegister,faMap,faChartPie, faChartBar, faMountain, faSuitcaseRolling, faSuitcase, faPlaneDeparture,faSms, faShareNodes, faSquareShareNodes,faUserPlus, faChartLine, faExternalLinkAlt, faChevronLeft, faThumbsUp,  faClock, faMagnifyingGlass, faPen, faPlus, faComment, faCopy, faTimes, faList,faTrash,faSearch, faArrowRotateRight, faChevronDown, faChevronRight, faShare, faChevronUp , faFlag, faUsers, faSmile, faMeh, faFrown, faRandom, faExpand, faCompress, faFolderPlus, faPlay, faPlayCircle, faAlignCenter, faAlignLeft, faAlignJustify, faAlignRight,faTable, faUpload, faListOl, faListDots, faEraser, faCircle, faCheckCircle, faExclamationTriangle, faInfoCircle, faCog, faAngleDown, faAngleUp, faWindowMaximize, faDotCircle, faHeart, faLink, faBus, faCalendarCheck,faCalendarAlt, faCompass, faCompassDrafting, faPhone, faPhoneAlt, faPhoneSquare, faUserAlt, faGlobe, faPassport, faArrowsH, faStar, faMapMarker, faMapMarkerAlt, faPager, faBars, faEnvelope, faCheck, faExternalLink, faSign, faPrint, faComments, faMobile, faMobileAlt, faFilePdf, faSync, faMale, faFemale, faTrain, faRefresh, faDownload, faSave, faReply, faEye, faQuestionCircle, faPlaneArrival, faEyeSlash, faCreditCard, faMoneyBill, faEllipsisV, faBuildingCircleCheck, faImage, faImages, faTags, faHotel, faMapLocationDot, faFilter, faArrowRight, faUser, faAward, faThLarge, faStickyNote, faArchive, faE, faCircleExclamation, faMinus, faDollarSign, faBookOpen, faKaaba, faListCheck, faStarAndCrescent, faGraduationCap, faBookQuran, faHandSparkles, faSliders, faChildReaching, faMicrophone, faCodeCompare, faDoorOpen, faPlane, faTrainSubway, faUserTie, faGem, faChild, faMousePointer, faShieldHalved, faSpellCheck, faWandMagicSparkles, faPaperclip, faArrowDownWideShort, faArrowUpShortWide, faRobot } from '@fortawesome/free-solid-svg-icons'
import { faApple, faFacebook, faGoogle ,faGooglePlay,faInstagram, faTwitter, faWhatsapp, faYoutube } from '@fortawesome/free-brands-svg-icons'
import {
  faBell,
  faMedal,
  faArrowDown,
  faArrowLeft,
  faArrowRightToBracket,
  faArrowUp,
  faArrowUpFromBracket,
  faBaby,
  faBullhorn,
  faCalendar,
  faChartColumn,
  faCircleNotch,
  faCircleXmark,
  faCrosshairs,
  faEquals,
  faFileCircleExclamation,
  faFileCsv,
  faFileExcel,
  faFileExport,
  faFileImport,
  faFileInvoiceDollar,
  faFileLines,
  faForward,
  faInbox,
  faLaptop,
  faMoneyBillTransfer,
  faMosque,
  faPeopleGroup,
  faRightLeft,
  faRotateLeft,
  faShield,
  faStop,
  faTableList,
  faTrophy,
  faUserCheck,
  faUserGroup,
  faVolumeHigh,
} from '@fortawesome/free-solid-svg-icons'

library.add(faTrain)
library.add(faTwitter)
library.add(faFacebook)
library.add(faShareNodes)
library.add(faSms)
library.add(faPen)
library.add(faPlus)
library.add(faWhatsapp)
library.add(faSquareShareNodes)
library.add(faCopy)
library.add(faTimes)
library.add(faList)
library.add(faTrash)
library.add(faSearch)
library.add(faTable)
library.add(faThumbsUp)
library.add(faMagnifyingGlass)
library.add(faComment)
library.add(faArrowRotateRight)
library.add(faChevronDown)
library.add(faChevronRight)
library.add(faChevronLeft)
library.add(faChevronUp)
library.add(faShare) 
library.add(faFlag) 
library.add(faList) 
library.add(faUsers) 
library.add(faClock) 
library.add(faFrown) 
library.add(faSmile) 
library.add(faMeh) 
library.add(faRandom)
library.add(faExpand)
library.add(faCompress)
library.add(faFolderPlus)
library.add(faPlay)
library.add(faPlayCircle)
library.add(faAlignCenter)
library.add(faAlignLeft)
library.add(faAlignRight)
library.add(faAlignJustify)
library.add(faUpload)
library.add(faListOl)
library.add(faListDots)
library.add(faEraser)
library.add(faCheckCircle)
library.add(faExclamationTriangle)
library.add(faInfoCircle)
library.add(faCog)
library.add(faChevronDown)
library.add(faAngleDown)
library.add(faAngleUp)
library.add(faWindowMaximize)
library.add(faDotCircle)
library.add(faHeart)
library.add(faLink)
library.add(faPlaneDeparture) 
library.add(faPlaneArrival)
library.add(faBus) 
library.add(faCalendarCheck) 
library.add(faCompass) 
library.add(faCompassDrafting) 
library.add(faPhone) 
library.add(faPhoneAlt) 
library.add(faPhoneSquare) 
library.add(faYoutube) 
library.add(faTwitter) 
library.add(faInstagram) 
library.add(faMagnifyingGlass)
library.add(faCircle)
library.add(faUserAlt)
library.add(faGlobe)
library.add(faPassport) 
library.add(faArrowsH)
library.add(faStar)
library.add(faMapMarker)
library.add(faMapMarkerAlt)
library.add(faPager)
library.add(faBars) 
library.add(faCalendarAlt) 
library.add(faSuitcaseRolling)
library.add(faSuitcase)
library.add(faMountain)
library.add(faCity)
library.add(faEnvelope)
library.add(faCheck)
library.add(faExternalLink)
library.add(faInfoCircle)
library.add(faComment)
library.add(faComments)
library.add(faSign)
library.add(faPrint)
library.add(faMobile)
library.add(faMobileAlt)
library.add(faFilePdf) 
library.add(faSync)
library.add(faMale)
library.add(faFemale)
library.add(faRefresh)
library.add(faDownload)
library.add(faSave)
library.add(faReply)
library.add(faEye)
library.add(faEyeSlash)
library.add(faQuestionCircle)
library.add(faCreditCard)
library.add(faMoneyBill)
library.add(faGoogle)
library.add(faInstagram)
library.add(faEllipsisV)
library.add(faBuildingCircleCheck)
library.add(faImages)
library.add(faTags)
library.add(faHotel)
library.add(faMapLocationDot)
library.add(faFilter)
library.add(faArrowRight)
library.add(faUser) 
library.add(faAward)
library.add(faLink)
library.add(faExternalLinkAlt)
library.add(faUserPlus)
library.add(faChartLine)
library.add(faEdit)
library.add(faFileInvoice)
library.add(faCashRegister)
library.add(faMap)
library.add(faChartPie)
library.add(faChartBar)
library.add(faWallet)
library.add(faCoins)
library.add(faBed)
library.add(faRoute)
library.add(faCalendarTimes)
library.add(faBuilding)
library.add(faCalculator)
library.add(faThLarge)
library.add(faStickyNote)
library.add(faTags)
library.add(faIdCard)
library.add(faUserSlash)
library.add(faGooglePlay)
library.add(faApple)
library.add(faArchive)
library.add(faCircleExclamation)
library.add(faMinus)
library.add(faDollarSign)
library.add(faBookOpen)
library.add(faKaaba)
library.add(faListCheck)
library.add(faStarAndCrescent)
library.add(faGraduationCap)
library.add(faBookQuran)
library.add(faHandSparkles)
library.add(faSliders)
library.add(faChildReaching)
library.add(faMicrophone)
library.add(faChevronUp)
library.add(faCodeCompare)
library.add(faFileInvoice)
library.add(faCalendarCheck)
library.add(faDoorOpen) 
library.add(faPlane)
library.add(faMicrophone)
library.add(faTrainSubway)
library.add(faUserTie)
library.add(faGem)
library.add(faChild)
library.add(faMousePointer)
library.add(faRotate)
library.add(faGauge)
library.add(faClipboardCheck)
library.add(faCakeCandles)
library.add(faPhoneSlash)
library.add(faKey)
library.add(faMessage)
library.add(faSpinner) 
library.add(faCrown) 
library.add(faHome) 
library.add(faTableColumns)
library.add(faPaperPlane)
library.add(faLock)
library.add(faShieldHalved)
library.add(faCalendarDay)
library.add(faCalendarDays)
library.add(faHeadset)
library.add(faSpellCheck)
library.add(faWandMagicSparkles)
library.add(faPaperclip)
library.add(faArrowDownWideShort)
library.add(faArrowUpShortWide)
library.add(faMoon)
library.add(faQuoteRight)
library.add(faRobot)
library.add(
  faBell,
  faMedal,
  faArrowDown,
  faArrowLeft,
  faArrowRightToBracket,
  faArrowUp,
  faArrowUpFromBracket,
  faBaby,
  faBullhorn,
  faCalendar,
  faChartColumn,
  faCircleNotch,
  faCircleXmark,
  faCrosshairs,
  faEquals,
  faFileCircleExclamation,
  faFileCsv,
  faFileExcel,
  faFileExport,
  faFileImport,
  faFileInvoiceDollar,
  faFileLines,
  faForward,
  faImage,
  faInbox,
  faLaptop,
  faMoneyBillTransfer,
  faMosque,
  faPeopleGroup,
  faRightLeft,
  faRotateLeft,
  faShield,
  faStop,
  faTableList,
  faTrophy,
  faUserCheck,
  faUserGroup,
  faVolumeHigh,
)
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('font-awesome-icon', FontAwesomeIcon)
})
